import React from "react";
import "./AppCardVideo.css";

export default function AppCardVideo({ thumbnail, title, descripcion, videoId, onClick }) {
  const handleClick = () => {
    if (videoId) {
      window.open(`https://www.youtube.com/watch?v=${videoId}`, "_blank", "noopener,noreferrer");
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <div className="vide-card">
      <img src={thumbnail} alt={title || "Video"} className="vide-img" />
      <div className="vide-body">
        {title && <p className="vide-title">{title}</p>}
        {descripcion && <p className="vide-subdesc">{descripcion}</p>}
        <button className="vide-btn" onClick={handleClick}>
          Ver video
        </button>
      </div>
    </div>
  );
}
